var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealthcare = function SvgHealthcare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "healthcare_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#healthcare_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0 .791-.077 1.567-.223 2.314a12.011 12.011 0 0 1-14.09 9.463 12.01 12.01 0 0 1-9.464-9.462 12.044 12.044 0 0 1 .001-4.628A12.01 12.01 0 0 1 9.685.223a12.042 12.042 0 0 1 4.629.001 12.008 12.008 0 0 1 9.685 11.777H24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.987 3.517V8.99h5.485v2.696h-6.9l-.998 1.85-1.04-4.86-1.184 3.026H3.503V8.99h5.484V3.517h6Zm-3.622 7.237.963 4.5 1.602-2.968h6.542v2.704h-5.485v5.497h-6V14.99H3.503v-2.688h7.257l.605-1.548Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "healthcare_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgHealthcare as ReactComponent };